import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from "../models/user";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public url: string;
  public identity;
  public token;
  public sessionActive: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public http: HttpClient
  ) {
    this.url = GLOBAL.url;
   }

   getIdentity() {
    const identity = JSON.parse(localStorage.getItem('identity'));
    if (identity !== 'undefined') {
      this.identity = identity;
    } else {
      this.identity = null;
    }
    return this.identity;
  }

  getToken() {
    const token = localStorage.getItem('token');
    if (token !== 'undefined') {
        this.token = token;
    } else {
        this.token = null;
    }
    return this.token;
  }

  destroy_session() {
    localStorage.removeItem('token');
    localStorage.removeItem('identity');
  }

  check_session(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.get(this.url + 'validate/session', { headers });
  }

  loginUser(parametros): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'user/login', parametros, { headers });
  }

  register(parametros): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'user/create', parametros, { headers });
  }

  activateUser(code: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.url + 'user/activation/' + code,  { headers });
  }

  recoveryPassword(parametros): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'user/recovery/password', parametros, { headers });
  }

  changePasswordRecovery(parametros): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'user/change/password', parametros, { headers });
  }

  generateRandomString(length) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  saveProfile(user: User): Observable<any> {
    let params = user; // JSON.stringify();
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.post(this.url + 'update/me', params, { headers });
  }

  getRandom() {
    return localStorage.getItem('avatar_random');
  }

  changeEmail(user): Observable<any> {
    let params = user; // JSON.stringify();
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.post(this.url + 'user/change/email', params, { headers });
  }

  autoriceEmailChange(parametros): Observable<any> {
    let params = parametros;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'autorice/email/change', params, { headers });
  }

  loginUserAdmin(parametros): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'user/login/admin', parametros, { headers });
  }


}
